import { useState, useEffect } from 'react'
import { Switch } from '@headlessui/react'
import ToggleDarkMode from '../../Hooks/ThemeHook'
import { SunIcon, MoonIcon } from '@heroicons/react/outline';

export default function Toggle(){
    const [colorTheme, setTheme] = ToggleDarkMode();
    const [enabled, setEnabled] = useState(false)
    

    useEffect(() => {
      if (localStorage) {
        try{
          let theme = localStorage.getItem("theme");
          if(theme) setTheme(theme);
        }catch(e){
        }
      }
    });
    return (
      <div className="flex flex-row w-full">
        <span className={`${colorTheme=== 'light'? 'invisible':'visible' }`}><SunIcon className="mr-2 h-6 text-white" aria-hidden="true"/></span>
        <Switch
          checked={enabled}
          onChange={()=> {
              try{
                localStorage.setItem("theme", colorTheme);
                setTheme(colorTheme);
              }catch(e){
              }
            }}
          className={`${
            colorTheme === 'light' ? 'bg-blue-600' : 'bg-gray-200'
          } relative inline-flex items-center h-6 rounded-full w-11`}
        >
          <span
            className={`${
              colorTheme === 'light' ? 'translate-x-6' : 'translate-x-1'
            } inline-block w-4 h-4 transform bg-white rounded-full`}
          />
        </Switch>
        <span className={`${colorTheme=== 'light'? 'visible':'invisible' }`}><MoonIcon className=" ml-2 h-6 text-white " aria-hidden="true"/></span>
      </div>
    )
}